import React from "react";
import { Button, Card, Typography, Divider } from "antd";
import {  ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text, Link } = Typography;

const AppPrivacyPolicy = ({ handleBackToMenu = () => {} }) => {
  return (
    <div style={{ padding: "24px", height: "100vh", overflow: "hidden" }}>
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={handleBackToMenu}
        style={{ marginBottom: 16 }}
      >
        Back
      </Button>
      <Card style={{ height: "100%", overflowY: "auto" }}>
        <Typography>
          {/* Important Notice Banner */}
          <div
            style={{
              background: "#f0f7ff",
              padding: "12px",
              borderLeft: "4px solid #4285F4",
              marginBottom: "16px", // Added for spacing
            }}
          >
            <strong>Business Use Disclosure:</strong> This app is designed for
            clinics/shops to manage queues via{" "}
            <a
              href="https://www.quetracker.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              quetracker.com
            </a>
            . All data processing occurs on the website, not in this app.
          </div>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderLeft: "4px solid #4285f4",
              padding: "16px",
              marginBottom: "24px",
            }}
          >
            <Text strong>Important Notice:</Text> This mobile app is a wrapper
            that displays content from{" "}
            <Link href="https://www.quetracker.com" target="_blank">
              quetracker.com
            </Link>
            . The app itself does not collect, store, or process any user data.
            All data collection is handled by the website through your browser.
          </div>

          <Title level={2}>Privacy Policy for QueTracker Mobile App</Title>
          <Text type="secondary">Last Updated: 20/06/2025</Text>

          <Divider />

          <Title level={3}>1. App Functionality</Title>
          <Paragraph>
            The QueTracker mobile application (Package ID:{" "}
            <Text code>com.queueAppManagement.myapp</Text>) is a Progressive Web
            App (PWA) wrapper that displays content from{" "}
            <Link href="https://www.quetracker.com" target="_blank">
              quetracker.com
            </Link>
            .
          </Paragraph>

          <Title level={3}>2. Data Collection</Title>
          <Paragraph>
            <Text strong>This app does not:</Text>
          </Paragraph>
          <ul>
            <li>Collect any personal information</li>
            <li>Store data on your device beyond standard caching</li>
            <li>Use cookies or tracking technologies</li>
            <li>Access device sensors (camera, microphone, etc.)</li>
          </ul>

          <Paragraph>
            All data collection described in the website's privacy policy occurs
            through your web browser's interaction with{" "}
            <Link href="https://www.quetracker.com" target="_blank">
              quetracker.com
            </Link>
            .
          </Paragraph>

          <Title level={3}>3. Website Privacy Policy</Title>
          <Paragraph>
            The complete privacy policy for the website content is available at:{" "}
            <Link
              href="https://www.quetracker.com/#/privacyPolicy"
              target="_blank"
            >
              https://www.quetracker.com/#/privacyPolicy
            </Link>
          </Paragraph>

          <Title level={3}>4. Permissions</Title>
          <Paragraph>This app may request the following permissions:</Paragraph>
          <ul>
            <li>
              <Text strong>Internet Access:</Text> Required to load the website
              content
            </li>
            <li>
              <Text strong>Network State:</Text> Used to check connectivity
              status
            </li>
          </ul>

          <Title level={3}>5. Changes to This Policy</Title>
          <Paragraph>
            Any changes to this wrapper app's policy will be posted at this URL
            with an updated revision date.
          </Paragraph>

          <Title level={3}>6. Contact</Title>
          <Paragraph>
            For questions about this mobile app, contact:{" "}
            <Link href="mailto:admin@mail.quetracker.com">
              admin@mail.quetracker.com
            </Link>
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
};

export default AppPrivacyPolicy;
